export let OffsetType;

(function (OffsetType) {
  OffsetType["xOffset"] = "xOffset";
  OffsetType["yOffset"] = "yOffset";
})(OffsetType || (OffsetType = {}));